import React from 'react'

const PaperClipIcon = props => (
  <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.9782 15.18c-1.7723 1.764-4.6387 1.764-6.411 0-1.7563-1.7569-1.7563-4.6031 0-6.36l6.3735-6.33c1.3317-1.3204 3.4802-1.3204 4.8119 0a3.3509 3.3509 0 01.9974 2.385 3.3509 3.3509 0 01-.9974 2.385l-5.8479 5.805a2.253 2.253 0 01-1.6027.6693 2.253 2.253 0 01-1.6028-.6693 2.249 2.249 0 01-.6623-1.5937 2.249 2.249 0 01.6623-1.5938l3.7085-3.675a.3755.3755 0 01.533 0l.4054.3975a.375.375 0 010 .5325l-3.7085 3.675a.9443.9443 0 00.0598 1.2749.9466.9466 0 001.2764.0526l5.848-5.7975a2.054 2.054 0 000-2.9175c-.814-.8085-2.1288-.8085-2.9428 0L4.4906 9.75c-1.2407 1.2439-1.2407 3.2561 0 4.5 1.2612 1.2359 3.2805 1.2359 4.5417 0l4.2415-4.2075a.3831.3831 0 01.5405 0l.3978.3975a.3598.3598 0 010 .525L9.9782 15.18z"
      fill="currentColor"
    />
  </svg>
)

PaperClipIcon.defaultProps = {
  width: 18,
  height: 18,
}

export default PaperClipIcon
